import { useMemo } from 'react';

import type { ActiveReaction } from '../../../../types/reactions';
import { REACTION_IMAGE } from '../../../../utils/reactions';
import {
  EmojiImage,
  FloatingReactionWrapper,
  PlayerName,
  PlayerNameWrapper,
} from '../../ReactionsOverlay.styled';

interface FloatingReactionProps {
  reaction: ActiveReaction;
}
export const FloatingReaction = ({ reaction }: FloatingReactionProps) => {
  const left = useMemo(() => 10 + Math.random() * 70, []);
  const bottom = useMemo(() => 5 + Math.random() * 10, []);

  return (
    <FloatingReactionWrapper $left={left} $bottom={bottom}>
      <EmojiImage
        src={REACTION_IMAGE[reaction.reactionType]}
        alt={reaction.reactionType}
      />
      <PlayerNameWrapper>
        <PlayerName>{reaction.player.username}</PlayerName>
      </PlayerNameWrapper>
    </FloatingReactionWrapper>
  );
};
